/**
 * Base URL for the backend API.
 * - Uses REACT_APP_API_URL if set (with us-centrall -> us-central1 fix).
 * - If not set and app is opened from production host (not localhost), use Cloud Run URL.
 * - Otherwise use local backend for development.
 */
// Same-origin path, not the Cloud Run hostname. Filtering resolvers block the
// *.run.app TLD outright, so a browser on corporate DNS or a VPN could not
// resolve the API at all — the app loaded and then sat empty. vercel.json
// proxies /api/* to Cloud Run, so the browser only resolves this origin.
const PRODUCTION_API = '/api';

function getApiUrl() {
  const env = process.env.REACT_APP_API_URL;
  if (env && env.trim()) {
    return env.replace('us-centrall.', 'us-central1.').trim();
  }
  if (typeof window !== 'undefined' && window.location && !/localhost|127\.0\.0\.1/i.test(window.location.origin)) {
    return PRODUCTION_API;
  }
  return 'http://localhost:6001';
}

export default getApiUrl;
